// 操作数据--获取请求的数据,然后调用 mutations内的方法实现数据的修改
import * as types from "./mutations-types";
import { userInfoAjax } from "@/services/loginRegister";
import {
  navInfoAjax,
  changeCompayAjax,
  rootLevelAjax,
  queryUserRoleResourceAjax,
} from "@/services/commonApi";
import { getMessageStatus } from "@/services/myMessage";
import { queryUserMembership } from "@/services/member";

//获取导航信息
export const navInfo = async function ({ commit, dispatch, state }, data) {
  let params = Object();
  Reflect.set(params, "companyCode", data);
  const resp = await navInfoAjax(params);
  const { result, status, success } = resp;
  if (status === 200 && success) {
    //权限控制作业
    if (IS_PERMISSION) {
      dispatch("getRoleResourceInfo").then(() => {
        //把通过权限获取的菜单添加到菜单中
        result.splice(4, 0, ...state.userroleresourceList);
        // state.userroleresourceList.forEach(item => {
        //   result.splice(4, 0, item)
        // })
      });
      let identityType = state.userInfo.identityType;
      // 普通用户没有班级管理
      if (identityType !== 0) {
        result.forEach((item) => {
          if (item.code === "team_manage") {
            item.url = "/home/managementclass";
          }
        });
      }
    }
    // 西安版本才有这玩意
    if (IS_PRIVATE && !IS_PERMISSION) {
      // if (IS_PRIVATE) {
      let identityType = state.userInfo.identityType;
      // 身份类型 0普通用户、1 老师、 2 学生、3校领导
      // 身份为老师校领导显示学生作业
      if (identityType === 1 || identityType === 3) {
        result.push({
          id: 10,
          name: "作业管理",
          nameEn: "Homework manage",
          code: "student_task",
          icon: "studentTask",
          url: "/home/homework-manage/homework-list",
          sort: 7,
          remark: "",
          showChild: 0,
          tagId: "",
          children: null,
        });
        // result.push({
        //   "id": 10,
        //   "name": "作业模式",
        //   "nameEn": "Task mode",
        //   "code": "task_mode",
        //   "icon": "taskMode",
        //   "url": "",
        //   "sort": 7,
        //   "remark": "",
        //   "showChild": 0,
        //   "tagId": "",
        //   "children": [
        //     {
        //       "id": 11,
        //       "name": "学生作业",
        //       "nameEn": "Student task",
        //       "code": "student_task",
        //       "icon": "studentTask",
        //       "url": "/home/jobManagement/studentTask",
        //       "sort": 33,
        //       "remark": "",
        //       "showChild": 0,
        //       "tagId": "",
        //       "children": null
        //     },
        //     {
        //       "id": 12,
        //       "name": "学生测试",
        //       "nameEn": "Student test",
        //       "code": "student_test",
        //       "icon": "studentTest",
        //       "url": "/home/jobManagement/studentTest",
        //       "sort": 34,
        //       "remark": "",
        //       "showChild": 0,
        //       "tagId": "",
        //       "children": null
        //     }
        //   ]
        // });
      } else if (identityType === 2) {
        // 身份为学生显示我的作业
        result.push({
          id: 13,
          name: "我的作业",
          nameEn: "My homework",
          code: "tstudent_ask_mode",
          icon: "taskMode",
          url: "/home/my-homework",
          sort: 8,
          remark: "",
          showChild: 0,
          tagId: "",
          children: null,
        });
        // result.push({
        //   "id": 13,
        //   "name": "作业模式",
        //   "nameEn": "Task mode",
        //   "code": "tstudent_ask_mode",
        //   "icon": "taskMode",
        //   "url": "",
        //   "sort": 8,
        //   "remark": "",
        //   "showChild": 0,
        //   "tagId": "",
        //   "children": [
        //     {
        //       "id": 14,
        //       "name": "我的作业",
        //       "nameEn": "My task",
        //       "code": "my_student_task",
        //       "icon": "myTask",
        //       "url": "/home/jobManagement/myTask",
        //       "sort": 35,
        //       "remark": "",
        //       "showChild": 0,
        //       "tagId": "",
        //       "children": null
        //     },
        //     {
        //       "id": 15,
        //       "name": "我的测试",
        //       "nameEn": "My test",
        //       "code": "my_student_test",
        //       "icon": "myTest",
        //       "url": "/home/jobManagement/myTest",
        //       "sort": 36,
        //       "remark": "",
        //       "showChild": 0,
        //       "tagId": "",
        //       "children": null
        //     }
        //   ]
        // });
      }
      // 普通用户没有班级管理
      if (identityType !== 0) {
        result.forEach((item) => {
          if (item.code === "team_manage") {
            item.url = "/home/managementclass";
          }
        });
      }
    }

    // 教学管理
    if (haveTeachManage && !IS_PRIVATE) {
      result.push({
        id: 10,
        name: "作业模式",
        nameEn: "Task mode",
        code: "task_mode",
        icon: "taskMode",
        url: "",
        sort: 7,
        remark: "",
        showChild: 0,
        tagId: "",
        children: [
          {
            id: 11,
            name: "学生作业",
            nameEn: "Student task",
            code: "student_task",
            icon: "studentTask",
            url: "/home/jobManagement/studentTask",
            sort: 33,
            remark: "",
            showChild: 0,
            tagId: "",
            children: null,
          },
          {
            id: 12,
            name: "学生测试",
            nameEn: "Student test",
            code: "student_test",
            icon: "studentTest",
            url: "/home/jobManagement/studentTest",
            sort: 34,
            remark: "",
            showChild: 0,
            tagId: "",
            children: null,
          },
          {
            id: 14,
            name: "我的作业",
            nameEn: "My task",
            code: "my_student_task",
            icon: "myTask",
            url: "/home/jobManagement/myTask",
            sort: 35,
            remark: "",
            showChild: 0,
            tagId: "",
            children: null,
          },
          {
            id: 15,
            name: "我的测试",
            nameEn: "My test",
            code: "my_student_test",
            icon: "myTest",
            url: "/home/jobManagement/myTest",
            sort: 36,
            remark: "",
            showChild: 0,
            tagId: "",
            children: null,
          },
        ],
      });
      // result.push(...[{
      //   id: 10,
      //   name: "作业管理",
      //   nameEn: "Homework manage",
      //   code: "student_task",
      //   icon: "studentTask",
      //   url: "/home/homework-manage/homework-list",
      //   sort: 7,
      //   remark: "",
      //   showChild: 0,
      //   tagId: "",
      //   children: null,
      // }, {
      //   id: 13,
      //   name: "我的作业",
      //   nameEn: "My homework",
      //   code: "tstudent_ask_mode",
      //   icon: "taskMode",
      //   url: "/home/my-homework",
      //   sort: 8,
      //   remark: "",
      //   showChild: 0,
      //   tagId: "",
      //   children: null,
      // }]);
    }

    // 是否含有入库审核记录的
    if (haveCorpusAuditRecords) {
      let corpusIndex = result.findIndex(
        (item) => item.code === "trans_memory"
      );
      // 如果存在语料库模块
      if (corpusIndex > -1) {
        // 获取语料库模块
        let corpusChildren = result.find(
          (item) => item.code === "trans_memory"
        ).children;
        corpusChildren.forEach((item) => {
          if (item.code === "memory_lib") {
            item.url = "/home/corpus/memoryLib";
          } else if (item.code === "term_lib") {
            item.url = "/home/corpus/termLib";
          }
        });
        corpusChildren.push({
          children: null,
          code: "audit_records",
          icon: "auditRecordsIcon",
          id: 8,
          name: "入库审核记录",
          nameEn: "Audit records",
          remark: "",
          showChild: 0,
          sort: 33,
          tagId: "",
          url: "/home/corpus/warehousingAudit",
        });
        result[corpusIndex].children = corpusChildren;
      }
    }
    result.sort(
      ((prop) => {
        return (a, b) => {
          let v1 = a[prop];
          let v2 = b[prop];
          return v1 - v2;
        };
      })("sort")
    );
    commit(types.SET_NAV_INFO, result);
    return resp;
  }
};
//
export const getRoleResourceInfo = async function ({ commit, state }, params) {
  if (state.userInfo.id) {
    const { result, success } = await queryUserRoleResourceAjax({
      id: state.userInfo.id,
    });
    if (success) {
      commit(types.SET_ROLERS_SOURCEINFO, result);
      commit("SET_ISROUTEFATAREADY", true);
    }
  }
};
//强制刷新
export const reloadNavInfo = async function ({ commit, state }) {
  commit(types.SET_NAV_INFO, JSON.parse(JSON.stringify(state.navInfo)));
};
//获取用户信息
export const userInfo = async function ({ commit, state }, data) {
  const resp = await userInfoAjax(Object());
  if (resp.status === 200 && resp.success) {
    const result = resp.result;
    localStorage.setItem(
      "lastSelectCompany",
      JSON.stringify(result.lastSelectCompany)
    );
    commit(types.SET_USER_INFO, result);
  }
  return resp;
};
// 退出团队后更新切换团队下拉框
export const newUserInfo = async function ({ commit, state }, data) {
  commit(types.SET_USER_INFO, data);
};
//获取小红点
export const showhidden = async function ({ commit }) {
  const { result, success } = await getMessageStatus({});
  if (success) {
    if (result === 0) {
      commit(types.SET_SHOW_HIDDEN, true);
    } else {
      commit(types.SET_SHOW_HIDDEN, false);
    }
  } else {
    commit(types.SET_SHOW_HIDDEN, true);
  }
};
//切换团队-公司
export const changeCompanyInfo = async function ({ commit, state }, data) {
  return await changeCompayAjax(data);
};
//获取最高权限
export const rootLevelInfo = async function ({ commit, state }, data) {
  const resp = await rootLevelAjax(Object());
  if (resp.status === 200 && resp.success) {
    const result = resp.result;
    commit(types.SET_ROOT_ID_INFO, result);
  }
};
//检测会员状态
export const checkMembership = async function ({ commit }, userId) {
  const defaultMemberInfo = {
    userId: userId ? String(userId) : "",
    active: false,
    validUntil: null,
    remainingSeconds: 0,
  };
  if (!userId) {
    commit(types.SET_MEMBER_INFO, defaultMemberInfo);
    return defaultMemberInfo;
  }
  try {
    const result = await queryUserMembership(userId, 0);
    const memberInfo = result || {};
    const normalizedMemberInfo = {
      userId: memberInfo.userId || String(userId),
      active: memberInfo.active === true,
      validUntil: memberInfo.validUntil || null,
      remainingSeconds: Number(memberInfo.remainingSeconds) || 0,
    };
    commit(types.SET_MEMBER_INFO, normalizedMemberInfo);
    return normalizedMemberInfo;
  } catch (e) {
    commit(types.SET_MEMBER_INFO, defaultMemberInfo);
    return defaultMemberInfo;
  }
};

export const updateMembership = function ({ commit }, membership = {}) {
  const normalizedMemberInfo = {
    userId: membership.userId ? String(membership.userId) : "",
    active: membership.active === true,
    membershipType: membership.membershipType || null,
    validUntil: membership.validUntil || null,
    remainingSeconds: Number(membership.remainingSeconds) || 0,
  };
  commit(types.SET_MEMBER_INFO, normalizedMemberInfo);
  return normalizedMemberInfo;
};
